import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const SplineChart = () => {
  const data = {
    labels: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    datasets: [
      {
        label: "Clicks",
        data: [56, 30, 70, 60, 80, 67, 85],
        borderColor: "#6d4dbf",
        backgroundColor: "#6d4dbf",
        tension: 0.5,
        fill: false,
        pointRadius: 0,
        borderWidth: 3,
      },
      {
        label: "Traffic",
        data: [20, 45, 40, 50, 42, 53, 48],
        borderColor: "#cc6ea0",
        backgroundColor: "#cc6ea0",
        tension: 0.5,
        fill: false,
        pointRadius: 0,
        borderWidth: 3,
      },
      {
        label: "Conversion",
        data: [28, 40, 30, 75, 52, 62, 20],
        borderColor: "#99a3e3",
        backgroundColor: "#99a3e3",
        tension: 0.5,
        fill: false,
        pointRadius: 0,
        borderWidth: 3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          padding: 20,
          font: {
            size: 14,
            weight: "500",
          },
          color: "#333",
        },
        tooltip: {
          enabled: true, // ❌ Turn off tooltip if you also don't want hover values
        },
        datalabels: {
          display: false, // ⛔ Explicitly disable data labels if plugin is registered
        },
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 14,
          },
        },
      },
      y: {
        min: 0,
        max: 100,
        grid: {
          color: "#f0f0f0",
        },
        ticks: {
          stepSize: 20,
          font: {
            size: 14,
          },
        },
      },
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false,
    },
  };

  return (
    <div style={{ height: "350px", width: "100%", maxWidth: "850px", margin: "0 auto" }}>
      <Line data={data} options={options} />
    </div>
  );
};

export default SplineChart;
